/** Countries where a Stripe Connect account can receive transfers. */
export const CONNECT_PAYOUT_COUNTRIES = [
  ["AE", "United Arab Emirates"],
  ["AT", "Austria"],
  ["AU", "Australia"],
  ["BE", "Belgium"],
  ["BG", "Bulgaria"],
  ["BR", "Brazil"],
  ["CA", "Canada"],
  ["CH", "Switzerland"],
  ["CY", "Cyprus"],
  ["CZ", "Czech Republic"],
  ["DE", "Germany"],
  ["DK", "Denmark"],
  ["EE", "Estonia"],
  ["ES", "Spain"],
  ["FI", "Finland"],
  ["FR", "France"],
  ["GB", "United Kingdom"],
  ["GI", "Gibraltar"],
  ["GR", "Greece"],
  ["HK", "Hong Kong"],
  ["HR", "Croatia"],
  ["HU", "Hungary"],
  ["IE", "Ireland"],
  ["IT", "Italy"],
  ["JP", "Japan"],
  ["LI", "Liechtenstein"],
  ["LT", "Lithuania"],
  ["LU", "Luxembourg"],
  ["LV", "Latvia"],
  ["MT", "Malta"],
  ["MX", "Mexico"],
  ["MY", "Malaysia"],
  ["NL", "Netherlands"],
  ["NO", "Norway"],
  ["NZ", "New Zealand"],
  ["PL", "Poland"],
  ["PT", "Portugal"],
  ["RO", "Romania"],
  ["SE", "Sweden"],
  ["SG", "Singapore"],
  ["SI", "Slovenia"],
  ["SK", "Slovakia"],
  ["TH", "Thailand"],
  ["US", "United States"],
];

export function isConnectPayoutCountry(code) {
  const normalized = String(code || "").trim().toUpperCase();
  return CONNECT_PAYOUT_COUNTRIES.some(([country]) => country === normalized);
}

export function connectCountryName(code) {
  const normalized = String(code || "").trim().toUpperCase();
  const match = CONNECT_PAYOUT_COUNTRIES.find(([country]) => country === normalized);
  return match ? match[1] : normalized;
}

/** EEA, UK, and Switzerland share the platform's Stripe service agreement. */
const PLATFORM_SERVICE_REGION = new Set([
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU",
  "IS", "IE", "IT", "LV", "LI", "LT", "LU", "MT", "NL", "NO", "PL", "PT", "RO",
  "SK", "SI", "ES", "SE", "GB", "CH",
]);

export function connectUsesRecipientAgreement(country) {
  return !PLATFORM_SERVICE_REGION.has(String(country || "").trim().toUpperCase());
}
